export const getSelectionCardVariant = (isLastElement, isNotLegTracking) => isLastElement && isNotLegTracking ? "selectionCardLast" : "selectionCard";
//# sourceMappingURL=getSelectionCardVariant.js.map